const urlChange = (url, queryString) => {
  let destination = queryString ? `${url}?${queryString}` : url;

  history.pushState(null, '', destination);
}

export default urlChange;
